// import echarts from "echarts";
import * as echarts from "echarts";

export function loadClzybChart(myChart, obj) {
  var salvProName = [];
  var salvProValue = [];
  for (let i in obj) {
    salvProName.push(obj[i].name);
    salvProValue.push(obj[i].sum);
  }
  myChart.setOption({
    grid: {
      left: "0%",
      right: "2%",
      bottom: "5%",
      top: "10%",
      containLabel: true
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "none"
      }
    },
    xAxis: {
      show: true,
      type: "value",
      nameTextStyle: {
        color: "#c0c3cd",
        padding: [0, 0, -10, 0],
        fontSize: 10
      },
      axisLabel: {
        color: "rgba(255,255,255,.5)",
        fontSize: 10
      },
      axisTick: {
        lineStyle: {
          color: "rgba(255,255,255,.5)",
          width: 1
        },
        show: true
      },
      splitLine: {
        lineStyle: {
          color: "rgba(255,255,255,.5)",
          width: 1,
          type: "dashed"
        },
        show: true
      },
      axisLine: {
        lineStyle: {
          color: "rgba(255,255,255,.5)",
          width: 1,
          type: "solid"
        },
        show: true
      }
    },
    yAxis: [
      {
        type: "category",
        inverse: true,
        axisLabel: {
          show: true,
          textStyle: {
            color: "#fff"
          }
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        data: salvProName
      },
      {
        type: "category",
        inverse: true,
        axisTick: "none",
        axisLine: "none",
        show: true,
        axisLabel: {
          textStyle: {
            color: "#ffffff",
            fontSize: 10
          }
        },
        data: salvProValue
      }
    ],
    series: [
      {
        type: "bar",
        zlevel: 1,
        itemStyle: {
          normal: {
            barBorderRadius: 0,
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              {
                offset: 0,
                color: "rgb(57,89,255,1)"
              },
              {
                offset: 1,
                color: "rgb(46,200,207,1)"
              }
            ])
          }
        },
        barWidth: 5,
        data: salvProValue
      }
    ]
  });
}
